<template>
    <div>
        <van-nav-bar
                title="Datos personales"
                left-text=""
                right-text=""
                left-arrow
                @click-left="onClickLeft"
                @click-right="onClickRight"
        >
            <template #left>
                <van-icon name="arrow-left" color="#000000" />
                <span>Volver</span>
            </template>
        </van-nav-bar>
        <div id="applyperson">
            <div class="apply_wrap">
                <div class="apply_banner">
                    <!--<img src="../../assets/img/applyhead.png" />-->
                </div>
                <div class="apply_head">
                    <div class="apply_hview">
                        <img src="../../assets/img/applyhead02.webp" />
                    </div>
                </div>


                <div class="apply_formview">

                    <div class="bank_conttop">
                        <div class="bank_ctitems" @click="onCheckitem('1')">
                            <div class="bank_ctitem" :class="isCheck == '1' ? 'bank_ctitem_active' : ''">
                                <div class="bank_ctileft">
                                    <template v-if="bankoneval == null">
                                        Nivel educativo
                                    </template>
                                    <template v-else>
                                        {{bankoneval.name}}
                                    </template>
                                </div>
                                <div class="bank_ctiright">
                                    <div class="bank_ctirview"><img src="../../assets/img/comf_rparrow.png" alt=""></div>
                                </div>
                            </div>
                        </div>


                        <div class="bank_ctitems" @click="onCheckitem('2')">
                            <div class="bank_ctitem" :class="isCheck == '2' ? 'bank_ctitem_active' : ''">
                                <div class="bank_ctileft">
                                    <template v-if="banktwoval == null">
                                        Estado civil
                                    </template>
                                    <template v-else>
                                        {{banktwoval.name}}
                                    </template>
                                </div>
                                <div class="bank_ctiright">
                                    <div class="bank_ctirview"><img src="../../assets/img/comf_rparrow.png" alt=""></div>
                                </div>
                            </div>
                        </div>


                        <div class="bank_ctitems" @click="onCheckitem('3')">
                            <div class="bank_ctitem" :class="isCheck == '3' ? 'bank_ctitem_active' : ''">
                                <div class="bank_ctileft">
                                    <template v-if="bankthrval == null">
                                        Número de hijos
                                    </template>
                                    <template v-else>
                                        {{bankthrval.name}}
                                    </template>
                                </div>
                                <div class="bank_ctiright">
                                    <div class="bank_ctirview"><img src="../../assets/img/comf_rparrow.png" alt=""></div>
                                </div>
                            </div>
                        </div>


                        <div class="applyFormtitle">
                            Región
                        </div>

                        <div class="bank_ctitems" @click="onCheckitem('4')">
                            <div class="bank_ctitem" :class="isCheck == '4' ? 'bank_ctitem_active' : ''">
                                <!--  <input v-model="bank_no" class="bank_code" type="number" /> -->
                                <van-field
                                        v-model="postalVal"
                                        label=""
                                        type="text"
                                        placeholder="Código postal"
                                        :clearable="isTrue"
                                        maxlength="5"
                                        @input="onPostalInput"
                                        @blur="onPostal"
                                />
                            </div>
                        </div>

                        <div class="bank_ctitems" @click="onCheckitem('5')">
                            <div class="bank_ctitem" :class="isCheck == '5' ? 'bank_ctitem_active' : ''">
                                <van-field
                                        v-model="coloniaVal"
                                        label=""
                                        type="text"
                                        placeholder="Colonia"
                                        :clearable="isTrue"
                                />
                            </div>
                        </div>

                        <div class="bank_ctitems" @click="onCheckitem('6')">
                            <div class="bank_ctitem" :class="isCheck == '6' ? 'bank_ctitem_active' : ''">
                                <van-field
                                        v-model="estadoVal"
                                        label=""
                                        type="text"
                                        placeholder="Estado"
                                        :clearable="isTrue"
                                />
                            </div>
                        </div>

                        <div class="applyFormtitle">
                            E-mail
                        </div>

                        <div class="bank_ctitems" @click="onCheckitem('7')">
                            <div class="bank_ctitem" :class="isCheck == '7' ? 'bank_ctitem_active' : ''">
                                <van-field
                                        v-model="emailVal"
                                        label=""
                                        type="text"
                                        placeholder="E-mail（Opcional）"
                                        :clearable="isTrue"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="bank_contmiddle">
                        <div class="bank_contmleft">
                            <div class="bank_contmlview">
                                <img src="../../assets/img/apply_useicon.png" />
                            </div>
                        </div>
                        <div class="bank_contmright">
                            <p>
                                Superapoyomax mantiene su información personal privada y segura durante todo el proceso.
                            </p>
                        </div>
                    </div>


                    <div class="bank_contdown">
                        <van-button round color="#19A95C" block style="height: 1.111111rem;" @click.stop="onConfirm">
                            <span style="font-weight: 500;">Enviar</span>
                        </van-button>
                    </div>

                </div>
            </div>

            <template v-show="bankoneShow">
                <van-action-sheet
                        v-model="bankoneShow"
                        :actions="actionsOne"
                        cancel-text="Cancelar"
                        description="Nivel educativo"
                        close-on-click-action
                        @select="onSelectOne"
                />
            </template>

            <template v-show="banktwoShow">
                <van-action-sheet
                        v-model="banktwoShow"
                        :actions="actionsTwo"
                        cancel-text="Cancelar"
                        description="Estado civil"
                        close-on-click-action
                        @select="onSelectTwo"
                />
            </template>

            <template v-show="bankthrShow">
                <van-action-sheet
                        v-model="bankthrShow"
                        :actions="actionsThr"
                        cancel-text="Cancelar"
                        description="Número de hijos"
                        close-on-click-action
                        @select="onSelectThr"
                />
            </template>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { getTimezoneName, getUserIp } from '@/utils/commonParams';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import { getAccessToken } from '@/utils/auth';

    import { postcodeGetCity, updateApplyProfilework } from '@/api/apply'
    import { getLoanInfo } from '@/api/loan';

    import { Toast } from 'vant';
    import $ from 'jquery';

    export default{
        data() {
            return {
                activeNav: 'living',
                isCheck: '1',
                isFalse: false,
                isTrue: true,
                bank_no: null,
                bankmessage: null,
                bankoneShow: false,
                // bankoneval: {
                //   id: 1,
                //   name: 'Maestría o doctorado'
                // },
                bankoneval: null,
                actionsOne: [
                    { id: '1', name: 'Maestría o doctorado'},
                    { id: '2', name: 'Licenciatura' },
                    { id: '3', name: 'Secundaria' },
                    { id: '4', name: 'Primaria' },
                    { id: '5', name: 'Ninguno' },
                ],
                banktwoShow: false,
                banktwoval: null,
                actionsTwo: [
                    { id: '1', name: 'Soltero'},
                    { id: '2', name: 'Casado'},
                    { id: '3', name: 'Divorciado'},
                ],
                bankthrShow: false,
                bankthrval: null,
                actionsThr: [
                    { id: '0', name: 'Ninguno'},
                    { id: '1', name: '1'},
                    { id: '2', name: '2'},
                    { id: '3', name: '3'},
                    { id: '4', name: 'Más de 3'},
                ],
                bankfurShow: false,
                bankfurval: null,
                minDate: new Date(2023, 7, 1),
                maxDate: new Date(2023, 7, 31),
                postalVal: null,
                coloniaVal: null,
                estadoVal: null,
                emailVal: '',
            }
        },
        mounted() {
            let account_profile = window.localStorage.getItem('account_profile');

            if(account_profile){
                account_profile = JSON.parse(account_profile);
                console.log(account_profile)
            }
        },
        methods: {
            onClickLeft() {
                this.$router.back();
            },
            onClickRight() {

            },
            onCheckitem(type){
                this.isCheck = type;
                if(type == '1'){
                    this.bankoneShow = true;
                } else if(type == '2'){
                    this.banktwoShow = true;
                } else if(type == '3'){
                    this.bankthrShow = true;
                } else if(type == '4'){
                    this.bankfurShow = true;
                }
            },
            onSelectOne(item) {
                console.log(item)
                this.bankoneval = item;
            },
            onSelectTwo(item) {
                this.banktwoval = item;
            },
            onSelectThr(item) {
                this.bankthrval = item;
            },
            onCalendarSelect(day) {
                let useDate = day.getDate();
                this.bankfurval = useDate;
                this.bankfurShow = false;
            },
            async getCommomParams(type) {
                let time_zone = getTimezoneName();
                console.log(time_zone);
                loadingShow();
                let ip = await getUserIp()
                console.log(ip)

                if(type == 'person'){
                    let commonParams = this.setCommonParams(time_zone, ip);
                } else if(type == 'info'){
                    let commonParams = this.infoCommonParams(time_zone, ip);
                }
            },
            setCommonParams(time_zone, ip){
                let access_token = getAccessToken();

                let _this = this;

                let bankoneval = this.bankoneval;
                let banktwoval = this.banktwoval;
                let bankthrval = this.bankthrval;

                let postalVal = this.postalVal;
                let coloniaVal = this.coloniaVal;
                let estadoVal = this.estadoVal;

                let emailVal = this.emailVal;

                /*let postData = {
                    marital_status: banktwoval.id, //ure_icr_gxp
                    children_number: bankthrval.id, //ngd_uib_jsi
                    current_addr: coloniaVal, //wst_qpy_qat
                    education: bankoneval.id, //uln_zyu_hwa
                    postal_code: postalVal, //jxc_xfw_xqa
                    detail_address: '', //mao_ekb_fks
                    cludad: estadoVal, //eax_zer_xvw
                    email: emailVal, // uby_gcg_ydf
                    job_type: '0', //fkv_ymb_tzh
                    monthly_income: '3', //qcj_gbs_chg
                };*/

                let postData = {
                    zzm_yya_hqb: access_token,
                    ure_icr_gxp: banktwoval.id,
                    ngd_uib_jsi: bankthrval.id,
                    wst_qpy_qat: coloniaVal,
                    uln_zyu_hwa: bankoneval.id,
                    jxc_xfw_xqa: postalVal,
                    mao_ekb_fks: estadoVal,
                    eax_zer_xvw: '',
                    uby_gcg_ydf: emailVal,
                    fkv_ymb_tzh: '1',
                    qcj_gbs_chg: '3',
                    aaa_off_csl: '111'
                };

                let headerParams = {
                    'ad-justad-id': localStorage.getItem("adjust_id"),
                    'ad-justad-j': '',
                    'ad-justad-idfv': '',
                };

                loadingShow();
                updateApplyProfilework(postData, {
                    'bwd-irh-lnf': time_zone,
                    'xfo-plp-van': ip,
                    ...headerParams
                }).then(res => {
                    console.log(res)
                    if (res.ci == 200) {
                        let useData = res.da;
                        console.log(JSON.parse(useData))
                        if (useData) {
                            let useDataJSON = JSON.parse(useData);
                            let { bqr_rle_jto } = useDataJSON;
                            if(bqr_rle_jto == 8001){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applywork'
                                })
                            } else if(bqr_rle_jto == 8002){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applycontacts'
                                })
                            } else if(bqr_rle_jto == 8004){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applyperson'
                                })
                            } else if(bqr_rle_jto == 8005){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applyidcard'
                                })
                            } else if(bqr_rle_jto == 8006){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/livingverify'
                                })
                            } else if(bqr_rle_jto == 7106){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/livingverify'
                                })
                            } else if(bqr_rle_jto == 8010){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applybank'
                                })
                            } else if(bqr_rle_jto == 7101){
                                this.gotoStatus()
                                // this.$router.replace({
                                //     path: '/loanpage/applyhome'
                                // })
                            } else if(bqr_rle_jto == 7102){
                                this.gotoStatus()
                                // this.$router.replace({
                                //     path: '/loanpage/applyhome'
                                // })
                            } else if(bqr_rle_jto == 7105){
                                this.gotoStatus()
                                // this.$router.replace({
                                //     path: '/loanpage/applyhome'
                                // })
                            } else if(bqr_rle_jto == 8110){
                                this.gotoStatus()
                                // this.$router.replace({
                                //     path: '/loanpage/applyhome'
                                // })
                            }
                        }
                    } else {
                        loadingHide()
                        Toast(res.ms);
                    }
                }, error => {
                    loadingHide()
                })
            },
            infoCommonParams(time_zone, ip){
                let access_token = getAccessToken();
                let _this = this;

                let postData = {
                    zzm_yya_hqb: access_token,
                    jxc_xfw_xqa: this.postalVal,
                    aaa_off_csl: '111'
                };

                console.log(postData)

                let headerParams = {
                    'ad-justad-id': localStorage.getItem("adjust_id"),
                    'ad-justad-j': '',
                    'ad-justad-idfv': '',
                };

                loadingShow();
                postcodeGetCity(postData, {
                    'bwd-irh-lnf': time_zone,
                    'xfo-plp-van': ip,
                    ...headerParams
                }).then(res => {
                    loadingHide()
                    if (res.ci == 200) {
                        let useData = res.da;
                        console.log(JSON.parse(useData))
                        if (useData) {
                            let useDataJSON = JSON.parse(useData);
                            console.log(useDataJSON)

                            let { vou_adm_wek, pri_szl_clk, hvc_ann_cnl, xyw_ges_qou } = useDataJSON;

                            let country = vou_adm_wek ? vou_adm_wek : '';
                            let state = pri_szl_clk ? pri_szl_clk : '';
                            let city = hvc_ann_cnl ? hvc_ann_cnl : '';
                            let zone = xyw_ges_qou ? xyw_ges_qou : '';

                            this.coloniaVal = city + ' ' + zone;
                            this.estadoVal = state;
                        }
                    } else {
                        Toast(res.ms);
                    }
                }, error => {
                    loadingHide()
                });

            },
            async gotoStatus() {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    getLoanInfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        this.isInfoLoading = false;
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                let {vkt_fnd_yzo, ojq_dzg_oxq } = useDataJSON;
                                //order_status, reapply_time, server_time current_is_reloan,
                                let { omi_fje_qly, huw_kdq_nxo, xhi_cur_ovl } = vkt_fnd_yzo;

                                console.log(omi_fje_qly);
                                console.log(huw_kdq_nxo);
                                console.log(ojq_dzg_oxq);
                                console.log(xhi_cur_ovl);

                                this.orderStatusNor = omi_fje_qly;
                                this.getStatus(omi_fje_qly, huw_kdq_nxo,  ojq_dzg_oxq, xhi_cur_ovl, _this);

                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                        this.isInfoLoading = false;
                    });
                } else { //未登录
                    console.log('未登录1111')
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })

                }
            },
            getStatus: (value, reapply_time, server_time, current_is_reloan, _this) => {
                switch (value) {
                    case 0:
                    case 10:
                    case 15:
                    case 17:
                    case 21:
                        console.log('0没有申请过,10失效,15展期结清,17展期失效,21等待签约');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.replace({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.replace({
                                path: '/loanpage/applyhome'
                            });
                        }
                        break;
                    case 1:
                    case 2:
                    case 4:
                    case 13:
                    case 18:
                    case 19:
                    case 20:
                        console.log('//1提交申请,2提交审核,4等待人工审核,13等待第三方黑名单验证,18等待自动外呼,19等待人脸对比,20人工审核质检中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 1;
                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 3:
                        console.log('//审核拒绝');
                        if (_this.canReloanByTime(reapply_time, server_time)) {
                            _this.orderStatus = 2;
                            /*if (_this.isReloan) {
                                if(current_is_reloan != undefined){
                                    if(current_is_reloan == 1){
                                        _this.isReloan = 1;
                                    } else {
                                        _this.isReloan = 1;
                                    }
                                } else {
                                    _this.isReloan = 1;
                                }
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {

                            }*/

                            if(current_is_reloan != undefined){
                                if(current_is_reloan == 1){
                                    _this.isReloan = 1;
                                } else {
                                    _this.isReloan = null;
                                }
                            } else {
                                _this.isReloan = null;
                            }

                            if(_this.isReloan == 1){
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {
                                _this.$router.replace({
                                    path: '/loanpage/applyhome'
                                });
                            }

                        } else {
                            _this.orderStatus = 1;
                            _this.loanStatus = 2;

                            _this.$router.replace({
                                path: '/loanpage/loanstatus'
                            });
                        }
                        break;
                    case 5:
                    case 12:
                        console.log('//5等待放款，12正在放款中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 3;

                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 6:
                        console.log('//放款失败');
                        _this.orderStatus = 1;
                        _this.loanStatus = 4;

                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 7:
                    case 9:
                    case 11:
                    case 14:
                    case 16:
                        console.log('7等待还款，9逾期，11部分还款，14等待展期，16展期申请中');
                        _this.orderStatus = 3;

                        _this.$router.replace({
                            path: '/loanpage/repayment'
                        });
                        break;
                    case 8:
                        console.log('8已结清');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 1;
                            }
                        } else {
                            _this.isReloan = 1;
                        }
                        _this.$router.replace({
                            path: '/loanpage/reapeatloan'
                        });
                        break;
                    case 22:
                        console.log('22等待订单再次确认');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 0;
                            }
                        } else {
                            _this.isReloan = 0;
                        }

                        _this.$router.replace({
                            path: '/loanpage/firstloan'
                        });
                        break;
                    default:
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.replace({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.replace({
                                path: '/loanpage/applyhome'
                            });
                        }
                }
            },
            canReloanByTime(repTime, stime) {
                return repTime < stime;
            },
            onConfirm() {
                let bankoneval = this.bankoneval;
                let banktwoval = this.banktwoval;
                let bankthrval = this.bankthrval;

                let postalVal = this.postalVal;
                let coloniaVal = this.coloniaVal;
                let estadoVal = this.estadoVal;

                let emailVal = this.emailVal;

                if(bankoneval && bankoneval.id){
                    if(banktwoval && banktwoval.id){
                        if(bankthrval){
                            if(postalVal){
                                if(coloniaVal){
                                    if(estadoVal){
                                        if(emailVal && emailVal.length > 0){
                                            let reg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
                                            if(reg.test(emailVal)){
                                                this.getCommomParams('person')
                                            } else {
                                                Toast('Formato de correo electrónico incorrecto') //邮箱格式错误
                                            }
                                        } else {
                                            this.getCommomParams('person')
                                        }

                                    } else {
                                        Toast('Ingresa dirección completa') //请输入详细地址
                                    }
                                } else {
                                    Toast('Ingresa información de estado') //请输入州信息
                                }
                            } else {
                                Toast('Ingresa código postal ') //请输入邮编
                            }
                        } else {
                            Toast('Elige cantidad de hijos') //请选择孩子数量
                        }
                    } else {
                        Toast('Elige el estado civil') //请选择婚姻状况
                    }
                } else {
                    Toast('Elige nivel de educación más alto') //请选择最高学历
                }
            },
            onPostal() {
                let postalVal = this.postalVal;
                console.log(postalVal)

                if(postalVal && postalVal.length){
                    //this.getCommomParams('info');
                }
            },
            onPostalInput(e) {
                console.log(e)
                if(e.length == 5){
                    this.getCommomParams('info');
                } else {
                    this.coloniaVal = null;
                    this.estadoVal = null;
                }
            },
        }
    }
</script>

<style less scoped>
    .apply_banner{
        width: 100%;
        height: 1.45rem;
        box-sizing: border-box;
        padding: 0.25rem 0.277778rem 0 0.277778rem;
        position: relative;
    }
    .apply_head{
        width: 100%;
        height: 0.75rem;
        position: relative;
    }
    .apply_hview{
        width: 8.944444rem;
        height: 0.555556rem;
        position: absolute;
        left: 0.56rem;
        top: -0.611111rem;
    }
    .apply_hview img{
        display: block;
        width: 8.944444rem;
        height: 0.555556rem;
    }
    .apply_formview{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0 0.555556rem;
    }
    .bank_conttop{
        width: 100%;
        height: auto;
    }
    .bank_ctitems{
        width: 100%;
        height: 1.472222rem;
    }
    .bank_ctitem{
        width: 100%;
        height: 1.111111rem;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 0.083333rem;
        border: 1px solid #DEE0E6;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .bank_ctitem_active{
        border: 1px solid #00CA88;
    }
    .bank_ctileft{
        width: auto;
        height: 14px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-left: 0.444444rem;
        font-size: 13px;
        font-weight: 500;
        color: #1A1A1A;
    }
    .bank_ctiright{
        width: auto;
        height: 8px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-right: 0.416667rem;
    }
    .bank_ctirview{
        width: 13px;
        height: 8px;
    }
    .bank_ctirview img{
        display: block;
        width: 13px;
        height: 8px;
    }
    .bank_ctiright_new{
        width: auto;
        height: 0.555556rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-right: 0.277778rem;
    }
    .bank_ctirview_new{
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .bank_ctirview_new img{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .bank_ctitem_active .bank_ctileft{
        color: #1A1A1A;
    }
    .bank_ctitem .bank_code{
        display: block;
        width: 90%;
        height: 0.8rem;
        outline: none;
        border: none;
        background: #ffffff;
        border-radius: 0.333333rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-left: 0.444444rem;
        font-size: 13px;
        font-weight: 500;
        color: #1A1A1A;
    }
    .bank_ctitem_active .bank_code{
        color: #1A1A1A;
    }
    .bank_contmiddle{
        width: 100%;
        height: 1.611111rem;
        display: flex;
        justify-content: flex-start;
    }
    .bank_contmleft{
        width: 0.666667rem;
        height: 0.444444rem;
    }
    .bank_contmlview{
        width: 0.394444rem;
        height: 0.444444rem;
        margin-top: 2px;
    }
    .bank_contmlview img{
        display: block;
        width: 0.394444rem;
        height: 0.444444rem;
    }
    .bank_contmright{
        width: 7.888889rem;
        height: 1.0rem;
        display: flex;
        align-items: center;
    }
    .bank_contmright p{
        font-size: 0.333333rem;
        font-weight: 500;
        color: #999999;
    }
    .bank_contdown{
        width: 7.722222rem;
        height: 1.111111rem;
        margin: 0 auto;
    }


    .applyFormtitle{
        width: 100%;
        height: 0.777778rem;
        font-size: 0.388889rem;
        font-weight: 600;
        color: #333333;
        line-height: 0.555556rem;
    }
</style>

<style less>
    #applyperson .van-action-sheet__description{
        background: #19A95C;
        color: #ffffff;
        font-size: 16px;
    }
    #applyperson .van-action-sheet__cancel{
        color: #FB4840;
    }
    #applyperson .van-action-sheet__item .van-action-sheet__name{
        color: #19A95C;
    }
    #applyperson .van-popup--bottom.van-popup--round{
        border-radius: 8px 8px 0px 0px;
    }
    #applyperson .van-cell{
        padding: 4px 0.444444rem 4px 0.416667rem;
    }
    #applyperson .van-dialog{
        width: 76.39vw;
        border-radius: 0.277778rem;
    }
    #applyperson .van-dialog__confirm, .van-dialog__confirm:active{
        background: #19A95C;
    }
</style>